import { Box, Divider, Typography } from '@mui/material';
import { fontWeights } from '@/@mui/tokens/font-weights';
import { useOffer } from '@/packages/courses/pages/details/context/offer';
import { formatMoney } from '@/utils/format-money';

export const RegressiveDiscount = () => {
  const { cheapestOffer } = useOffer();
  const regressiveDiscount = cheapestOffer?.regressive_discount;

  if (!regressiveDiscount) return null;

  return (
    <>
      <Box>
        <Typography fontWeight={fontWeights.fontWeightBold}>
          Desconto regressivo
        </Typography>
        <Typography>
          A partir do {regressiveDiscount.month}º mês, o desconto altera para{' '}
          {regressiveDiscount.discount}% e a mensalidade para{' '}
          <Typography
            component="span"
            color="primary.dark"
            fontWeight={fontWeights.fontWeightSemibold}
          >
            {formatMoney(regressiveDiscount.sale_price)}
          </Typography>
        </Typography>
      </Box>
      <Divider />
    </>
  );
};
